import { ApolloClient, InMemoryCache } from '@apollo/client-integration-nextjs';
import {
  CombinedGraphQLErrors,
  CombinedProtocolErrors,
} from '@apollo/client/errors';
import { ApolloLink } from '@apollo/client/link';
import { ErrorLink } from '@apollo/client/link/error';
import { HttpLink } from '@apollo/client/link/http';

import { BackendGraphqlApiConfig } from './get-backend-graphql-config';

import { getLogger } from '@/logger/get-logger';

export const makeApolloClient = (apiConfig: BackendGraphqlApiConfig) => {
  const uri = new URL(apiConfig.baseUrl);

  const { fetchOptions } = apiConfig;

  const logger = getLogger('ApolloClient', {
    host: uri.host,
  });

  logger.debug({ message: 'Creating Apollo Client' });

  const httpLink = new HttpLink({
    uri: uri.toString(),
  });

  const errorLink = new ErrorLink(({ error }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.forEach(({ message, locations, path }) =>
        logger.error({ message, locations, path }));

      return;
    }

    if (CombinedProtocolErrors.is(error)) {
      error.errors.forEach(({ message, extensions }) =>
        logger.error({ message, extensions: JSON.stringify(extensions) }));

      return;
    }

    logger.error(error);
  });

  return new ApolloClient({
    link: ApolloLink.from([
      errorLink,
      httpLink,
    ]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
    defaultContext: {
      fetchOptions,
    },
  });
};
